"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timeline = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/indicators/step/semantics/timeline-item");
/**
 * <mm-timeline>
 * 지나간 이력을 최근 것부터 한 선 위에 세우는 목록입니다.
 * 항목을 잇는 세로 선은 항목의 leading 아바타 가운데를 지납니다.
 */
let Timeline = class Timeline extends lit_1.LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'list');
    }
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
Timeline.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-4);
      position: relative;
      isolation: isolate;
    }

    :host::before {
      content: '';
      width: var(--border-width);
      background: var(--border-color);
      position: absolute;
      top: 0;
      bottom: 0;
      left: calc(var(--size-40) / 2);
    }

    /* 선은 항목 뒤로 지나가야 하므로 항목을 선 위로 올린다. */
    ::slotted(*) {
      position: relative;
      z-index: var(--material-zindex-elevated);
    }
  `;
Timeline = __decorate([
    (0, decorators_js_1.customElement)('mm-timeline')
], Timeline);
exports.Timeline = Timeline;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZWxpbmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0aW1lbGluZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWlEO0FBRWpELGdFQUE2RDtBQUU3RDs7OztHQUlHO0FBRUksSUFBTSxRQUFRLEdBQWQsTUFBTSxRQUFTLFNBQVEsZ0JBQVU7SUEyQnRDLGlCQUFpQjtRQUNmLEtBQUssQ0FBQyxpQkFBaUIsRUFBRSxDQUFBO1FBQ3pCLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLE1BQU0sQ0FBQyxDQUFBO0lBQ25DLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUFuQ00sZUFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7R0F3QmxCLENBQUE7QUF6QlUsUUFBUTtJQURwQixJQUFBLDZCQUFhLEVBQUMsYUFBYSxDQUFDO0dBQ2hCLFFBQVEsQ0FxQ3BCO0FBckNZLDRCQUFRIn0=